import data from "../../../configs/data";
import {Button} from "../../../controlElements/Button";
import {ObservableContainer} from "../../../controlElements/ObservableContainer";
import {DeviceDetector} from "../../../DeviceDetector";
import {EuropeanRoulette} from "../../../EuropeanRoulette";

export class LineBetsPanel extends ObservableContainer {

    private buttons: Array<Button> = [];

    private readonly POSSIBLE_LINE_BETS: Array<Array<number>> = [
        [0, 1, 2, 3],
        [1, 2, 3, 4, 5, 6],
        [4, 5, 6, 7, 8, 9],
        [7, 8, 9, 10, 11, 12],
        [10, 11, 12, 13, 14, 15],
        [13, 14, 15, 16, 17, 18],
        [16, 17, 18, 19, 20, 21],
        [19, 20, 21, 22, 23, 24],
        [22, 23, 24, 25, 26, 27],
        [25, 26, 27, 28, 29, 30],
        [28, 29, 30, 31, 32, 33],
        [31, 32, 33, 34, 35, 36],
    ];

    constructor(straightBetsButtonsOffsetX: number,
                straightBetsButtonsOffsetY: number,
                straightBetsOffsetFromZero: number) {
        super();
        this.createAndAddBetsButtons(
            straightBetsButtonsOffsetX,
            straightBetsButtonsOffsetY,
            straightBetsOffsetFromZero);
    }

    public getButtonPosition(number: number): PIXI.Point {
        return (this.buttons[number].position as PIXI.Point);
    }

    private createAndAddBetsButtons(straightBetsButtonsOffsetX: number, straightBetsButtonsOffsetY: number,
                                    straightBetsOffsetFromZero: number): void {
        for (let index = 0;
             index < EuropeanRoulette.ROULETTE_MAXIMUM_NUMBER / 3; index++) {
            const button = new Button(data.images.regularNumberBaseState, data.images.regularNumberBaseState,
                data.images.regularNumberBaseState, data.images.regularNumberHoverDisableState);

            this.initializeBetButtonBehavior(button, index);
            button.position.x = straightBetsOffsetFromZero - straightBetsButtonsOffsetX / 2 +
                index * straightBetsButtonsOffsetX;
            button.position.y = straightBetsButtonsOffsetY * 2 + straightBetsButtonsOffsetY / 2;
            this.buttons.push(button);
            this.addChild(button);
        }
    }

    private onValueChosen(index: number): void {
        this.callOnClickedSubscribers(index, this.POSSIBLE_LINE_BETS[index]);
    }

    private onHover(index: number): void {
        this.callOnPointerDownSubscribers(index, this.POSSIBLE_LINE_BETS[index]);
    }

    private onHoverOutside(index: number): void {
        this.callOnPointerUpSubscribers(index, this.POSSIBLE_LINE_BETS[index]);
    }

    private initializeBetButtonBehavior(button: Button, thisArg: any): void {
        button.subscribeOnClicked(this.onValueChosen.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_DOWN, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_CANCEL, this.onHoverOutside.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OVER, this.onHover.bind(this, thisArg));
        button.on(Button.BUTTON_EVENTS.POINTER_OUT, this.onHoverOutside.bind(this, thisArg));
        if (DeviceDetector.isMobileOrTabletDevice()) {
            button.on(Button.BUTTON_EVENTS.POINTER_UP, this.onHoverOutside.bind(this, thisArg));
            button.on(Button.BUTTON_EVENTS.POINTER_UP_OUTSIDE, this.onHoverOutside.bind(this, thisArg));
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/userInterface/rouletteBetsPanel/implementations/LineBetsPanel.ts